import { StyledDropdown } from 'baseui/select';
import React from 'react';
import * as meta from '../../meta-data.json';
import { getBaseCustomProps, getFormCustomProps } from '../../Utilities/types/SharedProps';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { paddingSize } from '../../Utilities/utils/Theming';
import {
	inputSizesStyle,
	multiSumaryDropdown,
	popOverBodyStyle,
	tagOverrideDropdown,
	valueContainerInputBadge,
	valueContainerPaddingStyles,
} from '../Dropdown/styles';
import { MIcon } from '../Icon';
import { dropdownStatusStyle, rootStyle, singleValueSizesStyle } from './styles';

export const overrides = (
	props: any,
	positive: boolean,
	warning: boolean,
	icon: string,
	css: any,
	ref: any,
	selectRef: any,
) => {
	const HTMLAttrs = getHTMLAttributes(props);

	return {
		Root: {
			style: () => {
				return { ...rootStyle(props.size) };
			},
			props: {
				className: props.className,
				...getBaseCustomProps(props),
				...HTMLAttrs.dataProps,
				'data-epo': 'epo-dropdown-root',
				'data-testid': 'epo-phone-dropdown-root',
			},
		},
		/* BORDERS AND COLORS */
		ControlContainer: {
			style: ({ $isFocused, $error, $multi, $theme, $disabled }: any) => {
				return {
					...(dropdownStatusStyle(
						$error,
						warning,
						positive,
						$isFocused,
						$disabled,
						$theme,
						props.readOnly,
					) as any),
					...props.ControlContainerStyle,
					cursor: 'pointer',
				};
			},
			props: { 'data-epo': `epo-dropdown-${meta.version}`, part: `epo-dropdown-${meta.version}` },
		},
		/* SPACING */
		SingleValue: {
			style: () => {
				return { ...singleValueSizesStyle(props.size) };
			},
			props: {
				'data-epo': 'epo-dropdown-single-value',
				'data-testid': 'epo-dropdown-single-value',
			},
		},
		Input: {
			style: () => {
				return {
					...inputSizesStyle(props),
				};
			},
			props: {
				...getFormCustomProps(props),
				...props.InputProps,
				...HTMLAttrs.ariaProps,
				autoComplete: 'off',
				tabIndex: props.tabIndex || 0,
				'data-epo': 'epo-dropdown-input',
			},
		},
		ValueContainer: {
			style: ({ $theme }: any) => {
				return {
					...(valueContainerInputBadge(props) as any),
					...(valueContainerPaddingStyles($theme, props) as any), // left paddings
					color: 'var(--epods--color-text-primary)',
				};
			},
			props: {
				'data-epo': 'epo-dropdown-value-container',
			},
		},
		/* CHEVRON */
		SelectArrow: {
			component: () => (
				<span
					data-epo="epo-dropdown-select-arrow"
					className={css({
						pointerEvents: 'none',
						display: 'block',
						height: '18px',
						lineHeight: 'var(--epods--font-size-p)',
						marginLeft: 'var(--epods--dropdown-action-icon-spacing)',
					})}
				>
					<MIcon
						icon={'keyboard_arrow_down'}
						color={
							props.disabled ? 'var(--epods--color-text-disabled)' : 'var(--epods--color-text-primary)'
						}
						size="small"
					/>{' '}
				</span>
			),
		},
		IconsContainer: {
			style: () => {
				return {
					paddingRight: 0,
				};
			},
			props: {
				'data-epo': 'epo-dropdown-icons-container',
			},
		},
		/* DROPDOWN */
		Popover: {
			props: {
				...props.PopoverProps,
				mountNode: ref.current,
				'data-epo': 'epo-dropdown-popover',
				overrides: {
					Body: {
						style: () => ({
							...popOverBodyStyle(),
						}),
						props: {
							...props.PopoverBodyProps,
							'data-epo': `epo-dropdown-${meta.version}`,
							part: `epo-dropdown-${meta.version}`,
						},
					},
				},
			},
		},
		Dropdown: {
			style: () => {
				return {
					...paddingSize('0', '0', '0', '0'),
					boxShadow: 'none',
					':focus': { outline: '0' },
					...props.DropdownStyle,
				};
			},
		},
		DropdownContainer: {
			style: () => {
				return {
					boxShadow: 'none',
					backgroundColor: 'var(--epods--color-bg-third-elevation)',
					...props.DropdownContainerStyle,
				};
			},
			props: { 'data-epo': `epo-dropdown-${meta.version}`, part: `epo-dropdown-${meta.version}` },
		},
		/* TAGS OVERRIDES */
		MultiValue: {
			...tagOverrideDropdown(props),
		},
		/* CONFIGURATION FOR THE MULTI WITH BADGE: FROM PRESETS */
		InputContainer: {
			...multiSumaryDropdown(props, css),
		},
		/* INPUT AND VALUES */
		LoadingIndicator: {},
	};
};
